import { render } from "./ProfileClientComponent.vue?vue&type=template&id=2baac154&scoped=true"
import script from "./ProfileClientComponent.vue?vue&type=script&lang=js"
export * from "./ProfileClientComponent.vue?vue&type=script&lang=js"

import "./ProfileClientComponent.vue?vue&type=style&index=0&id=2baac154&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2baac154"]])

export default __exports__